// tslint:disable:max-line-length
import React from 'react';

const HomeIcon: React.SFC<{}> = () => (
    <svg viewBox="0 0 100 100">
        <polyline
            fill="none"
            stroke="currentColor"
            strokeWidth="6px"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="4.7 51.49 50.13 7.75 94.71 50.23"
        />
        <polygon
            fill="currentColor"
            points="83.35 41.4 83.35 91.88 58.95 91.88 58.95 67.48 39.61 67.48 39.61 91.45 16.48 91.45 16.48 41.82 50.12 7.76 83.35 41.4"
        />
        <polygon
            fill="none"
            stroke="currentColor"
            strokeWidth="0.88px"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="83.35 41.4 83.35 91.88 58.95 91.88 58.95 67.48 39.61 67.48 39.61 91.45 16.48 91.45 16.48 41.82 50.12 7.76 83.35 41.4"
        />
    </svg>
);
export { HomeIcon };
